module.exports = __webpack_public_path__ + "static/Wesfarmers-case-study-video-light-397de9da82beb0a932bf797d1624285b.mp4";